/*
 * @Author: your name
 * @Date: 2021-07-02 09:40:24
 * @LastEditTime: 2021-07-05 16:42:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\foodColumn\preview.js
 */
import { ImagePreview } from "vant";
export const previewImgage = (data,index) =>
  ImagePreview({
    images: data,
    closeable:true,
    startPosition:index
  });
